import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShareSimulationPage() {
  const [ogData, setOgData] = useState(null);
  const [previewImg, setPreviewImg] = useState(null);

  useEffect(() => {
    // Get first flyer for simulation
    axios.get(`${API}/flyers`, { params: { limit: 1 } })
      .then(async ({ data }) => {
        if (data.flyers?.[0]) {
          const flyerId = data.flyers[0].id;
          const ogRes = await axios.get(`${API}/flyers/${flyerId}/og`);
          setOgData(ogRes.data);
          // Get first preview image
          if (ogRes.data.preview_images?.[0]) {
            const img = ogRes.data.preview_images[0];
            // For external URLs, use directly
            setPreviewImg(`https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=400&q=80`);
          }
        }
      })
      .catch(() => {});
  }, []);

  const shopName = ogData?.shop_name || 'Casa & Stile';
  const title = ogData?.title || 'Nuove Offerte - Casa & Stile';
  const desc = ogData?.description || '4 prodotti da 14€ a 34€ - Offerte del giorno';
  const productCount = ogData?.product_count || 4;
  const priceRange = ogData?.price_range || 'da 14€ a 34€';
  const flyerDate = ogData?.flyer_date || '2026-04-18';
  const siteUrl = (typeof window !== 'undefined' ? window.location.host : 'photovendo.com');
  const now = new Date().toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });

  return (
    <div data-testid="share-simulation" className="min-h-screen" style={{ background: '#0b141a' }}>
      {/* Header */}
      <div className="text-center pt-6 pb-4">
        <h1 className="text-xl font-bold text-white" style={{ fontFamily: 'Outfit' }}>
          Simulazione Condivisione Social
        </h1>
        <p className="text-white/50 text-xs mt-1">Come appare il volantino quando lo condividi</p>
      </div>

      <div className="max-w-lg mx-auto px-4 space-y-8 pb-12">

        {/* ========== WHATSAPP ========== */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-full bg-[#25D366] flex items-center justify-center">
              <svg viewBox="0 0 24 24" fill="white" width="18" height="18"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/><path d="M12 0C5.373 0 0 5.373 0 12c0 2.625.846 5.059 2.284 7.034L.789 23.492l4.625-1.476A11.929 11.929 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.75c-2.115 0-4.1-.656-5.744-1.781l-.412-.27-2.744.877.87-2.638-.293-.435A9.709 9.709 0 012.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75z"/></svg>
            </div>
            <span className="text-white font-medium text-sm">WhatsApp</span>
            <span className="text-white/30 text-xs">- Gruppo "Clienti Casa & Stile"</span>
          </div>

          {/* WhatsApp Chat Bubble */}
          <div style={{ background: '#1f2c34' }} className="rounded-2xl overflow-hidden">
            {/* Chat header */}
            <div className="bg-[#202c33] px-4 py-2 flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-[#C25934] flex items-center justify-center text-white text-xs font-bold">CS</div>
              <div>
                <p className="text-white text-sm font-medium">Casa & Stile</p>
                <p className="text-[#8696a0] text-[10px]">online</p>
              </div>
            </div>

            {/* Message */}
            <div className="p-3">
              <div className="bg-[#005c4b] rounded-xl rounded-tl-sm max-w-[85%] overflow-hidden ml-auto">
                {/* Link Preview */}
                <div className="bg-[#025144] rounded-t-lg overflow-hidden">
                  <img
                    src="https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=400&q=80"
                    alt="preview"
                    className="w-full h-40 object-cover"
                  />
                  <div className="p-2.5">
                    <p className="text-[#a7d8c8] text-[10px] uppercase tracking-wider">{siteUrl}</p>
                    <p className="text-white text-sm font-medium mt-0.5">{title}</p>
                    <p className="text-[#8696a0] text-xs mt-0.5">{desc}</p>
                  </div>
                </div>
                {/* Message text */}
                <div className="px-2.5 pt-1.5 pb-1">
                  <p className="text-white text-sm">
                    Nuove offerte appena arrivate! {productCount} prodotti {priceRange} 🔥
                  </p>
                  <p className="text-[#a7d8c8] text-sm mt-1">
                    👉 Guarda il volantino completo
                  </p>
                  <div className="flex justify-end mt-1">
                    <span className="text-[#8696a0] text-[10px]">{now} ✓✓</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ========== TELEGRAM ========== */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-full bg-[#0088cc] flex items-center justify-center">
              <svg viewBox="0 0 24 24" fill="white" width="18" height="18"><path d="M11.944 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0a12 12 0 00-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 01.171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.479.33-.913.492-1.302.48-.428-.012-1.252-.242-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/></svg>
            </div>
            <span className="text-white font-medium text-sm">Telegram</span>
            <span className="text-white/30 text-xs">- Canale "Offerte Casa & Stile"</span>
          </div>

          {/* Telegram Message - Bot auto-post */}
          <div style={{ background: '#17212b' }} className="rounded-2xl overflow-hidden">
            <div className="bg-[#1e2c3a] px-4 py-2 flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-[#C25934] flex items-center justify-center text-white text-xs font-bold">🤖</div>
              <div>
                <p className="text-white text-sm font-medium">PhotoVendo Bot</p>
                <p className="text-[#6d8292] text-[10px]">bot</p>
              </div>
            </div>

            <div className="p-3">
              {/* Auto-posted product message (Telegram Bot) */}
              <div className="bg-[#182533] rounded-xl overflow-hidden max-w-[85%]">
                <img
                  src="https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=400&q=80"
                  alt="product"
                  className="w-full h-44 object-cover"
                />
                <div className="p-3">
                  <p className="text-white text-sm font-bold">Set Lenzuola Matrimoniali in Raso</p>
                  <p className="text-[#8b9fad] text-xs mt-1">
                    Set completo lenzuola matrimoniali in raso di cotone. Morbide e traspiranti, disponibili in diversi colori.
                  </p>
                  <p className="text-white text-base font-bold mt-2">
                    34.90€ <span className="text-[#8b9fad] text-xs line-through">49.90€</span> <span className="text-[#e74c3c] text-xs">(-30%)</span>
                  </p>
                  <p className="text-[#8b9fad] text-xs mt-1">📌 Colore: Bianco, Grigio Perla, Azzurro, Rosa</p>
                  <p className="text-[#8b9fad] text-xs">📌 Misura: Matrimoniale, Piazza e mezza</p>
                  <p className="text-[#6ab3f3] text-xs mt-2 underline">🛒 Acquista ora</p>
                  <p className="text-[#8b9fad] text-[10px] mt-1">🏪 Casa & Stile</p>
                  <div className="flex justify-end">
                    <span className="text-[#6d8292] text-[10px]">{now}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ========== FACEBOOK ========== */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-full bg-[#1877F2] flex items-center justify-center">
              <svg viewBox="0 0 24 24" fill="white" width="18" height="18"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </div>
            <span className="text-white font-medium text-sm">Facebook</span>
            <span className="text-white/30 text-xs">- Gruppo "Offerte per la Casa - Roma"</span>
          </div>

          {/* Facebook Post */}
          <div className="bg-[#242526] rounded-xl overflow-hidden">
            {/* Post header */}
            <div className="px-4 py-3 flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[#C25934] flex items-center justify-center text-white text-sm font-bold">CS</div>
              <div>
                <p className="text-white text-sm font-medium">Casa & Stile</p>
                <p className="text-[#b0b3b8] text-xs">Adesso · 🌐</p>
              </div>
            </div>

            {/* Post text */}
            <div className="px-4 pb-2">
              <p className="text-[#e4e6eb] text-sm">
                Nuove offerte appena arrivate! 🔥 {productCount} prodotti {priceRange}
              </p>
              <p className="text-[#e4e6eb] text-sm mt-1">
                👉 Guarda il volantino completo e ordina subito!
              </p>
            </div>

            {/* Link preview */}
            <div className="border-t border-[#3e4042]">
              <img
                src="https://images.unsplash.com/photo-1522771739844-6a9f6d5f14af?w=600&q=80"
                alt="preview"
                className="w-full h-52 object-cover"
              />
              <div className="bg-[#3a3b3c] px-4 py-2.5">
                <p className="text-[#b0b3b8] text-[10px] uppercase">{siteUrl}</p>
                <p className="text-[#e4e6eb] text-sm font-medium">{title}</p>
                <p className="text-[#b0b3b8] text-xs">{desc}</p>
              </div>
            </div>

            {/* Reactions */}
            <div className="px-4 py-2 flex items-center justify-between border-t border-[#3e4042]">
              <div className="flex items-center gap-1">
                <span className="text-sm">👍❤️</span>
                <span className="text-[#b0b3b8] text-xs">24</span>
              </div>
              <span className="text-[#b0b3b8] text-xs">8 commenti · 12 condivisioni</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
